import { NavigationContainerRef } from '@react-navigation/native'
import { createRef } from 'react'

export let navigationRef = createRef<NavigationContainerRef<any>>()
export const getNavRef = () => navigationRef
